import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import Button from 'src/components/buttons/button';
import { setAlert } from 'src/typescript/components/alert/actions';
import signupContext from 'src/constants/signupContext';
import { showSignupModal } from 'src/modules/shared/modal/actions';
import { throttle } from 'lodash';
import { userIsMemberOfCurrentGroup } from 'src/utils/context';
import { connect } from 'react-redux';
import { likePost, unlikePost } from 'src/modules/community/singlePost/actions/actions';
import i18n from 'src/utils/translate';
import { trackFootfallEvent } from 'src/utils/footfall';
import footfallEventTypes from 'src/constants/footfallEventTypes';

class LikeButton extends React.Component {
  static propTypes = {
    isDisabled: PropTypes.bool,
    post: PropTypes.object.isRequired,
    showNumber: PropTypes.bool,
    signupContext: PropTypes.object,
    superPost: PropTypes.object,
    noText: PropTypes.bool,
  };

  static defaultProps = {
    showNumber: true,
    noText: false,
    signupContext: {
      element: signupContext.element.LIKE,
      section: signupContext.section.UNTRACKED,
    },
    post: {},
  };

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false,
    };
  }

  onClick = () => {
    const { post, superPost, isActive, isDisabled, currentUser, community, showSignupModal, setAlert } = this.props;
    if (isDisabled) return;

    if (!isActive) {
      const trackingContext = {
        section: this.props.signupContext.section || signupContext.section.UNTRACKED,
        element: this.props.signupContext.element || signupContext.element.LIKE,
      };
      trackFootfallEvent(footfallEventTypes.CLICKED, {
        clickType: 'sign-up',
        clickMetadata: trackingContext,
      });
      showSignupModal(
        trackingContext,
        community,
      );
      return;
    }

    if (isActive && !userIsMemberOfCurrentGroup(currentUser, community)) {
      setAlert(i18n.t('You’ll need to become a community member to be able to Like.'));
      return;
    }

    const parentPost = superPost || post;

    if (!post.hasRated) {
      this.props.likePost(post.id, parentPost.id, community.slug);
    } else {
      this.props.unlikePost(post.id, parentPost.id, community.slug);
    }
  };

  throttledClick = throttle(this.onClick, 1000);

  render() {
    const { isDisabled, post: { numRatings, hasRated, id }, showNumber, isActive, noText } = this.props;
    let likesNumber = '';

    if (showNumber) likesNumber = `(${numRatings || 0})`;

    if (!!noText && !!numRatings && numRatings.toString() === '0') likesNumber = '';

    const buttonText = !!hasRated && this.state.isHovered
      ? i18n.t('Unlike')
      : `${i18n.t('Like')} ${likesNumber}`;

    const iconClassName = classNames({
      'icon--success': !!hasRated,
    });

    let iconName;

    iconName = (!!hasRated) || (!hasRated && !!this.state.isHovered)
    ? 'like-filled'
    : 'like-outline';

    if (isDisabled) iconName = 'like-outline';

    return (
      <Button
        className="post-action post-action--like"
        disabled={isDisabled}
        icon={iconName}
        iconClassName={iconClassName}
        key={'recommend' + id}
        size="sm"
        text={noText ? likesNumber : buttonText}
        type={isDisabled ? 'tertiary' : 'secondary'}
        onClick={isActive ? this.throttledClick : this.onClick}
        onMouseEnter={() => this.setState({ isHovered: true })}
        onMouseLeave={() => this.setState({ isHovered: false })}
      />
    );
  }
}

export default connect(null, { likePost, unlikePost, showSignupModal, setAlert })(LikeButton);
